import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Button } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { getBreakTypeName, getBreakForbiddenReasonString } from '../breakOptionsModalHelpers';
import { useTimeFormatters } from '../../../../../utils/Hooks/venue/useVenueTimeFormatters';
import {
  StepContentContainer,
  ModalTitle,
  BreakInfoText,
  WarningContainer,
  WarningText,
  StyledTextField,
  ButtonContainer,
} from '../BreakOptionsModal.styles';

const WaiverConfirmationStep = ({ selectedBreak, reason, setReason, isLoading, onWaiveSubmit }) => {
  const { formatTime } = useTimeFormatters();
  return (
    <StepContentContainer>
      <ModalTitle variant="h6" component="h2">
        Waive Break Confirmation
      </ModalTitle>

      <BreakInfoText variant="body1">
        You are about to waive your upcoming <strong>{getBreakTypeName(selectedBreak?.type)}</strong>
        {selectedBreak?.scheduledStart && (
          <>
            {' '}
            scheduled for <strong>{formatTime(new Date(selectedBreak.scheduledStart))}.</strong>
          </>
        )}
      </BreakInfoText>

      <BreakInfoText variant="body2" sx={{ opacity: 0.7 }}>
        Please provide a reason for waiving this break. This information will be recorded and may be reviewed by
        management.
      </BreakInfoText>

      {selectedBreak?.canBeWaived === false && selectedBreak?.waivingForbiddenReason && (
        <WarningContainer>
          <WarningIcon color="warning" />
          <WarningText>
            <strong>Warning: </strong>
            {getBreakForbiddenReasonString(selectedBreak)} Waiving this break will cause a violation.
          </WarningText>
        </WarningContainer>
      )}

      <StyledTextField
        label="Reason for waiving break"
        multiline
        rows={3}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Enter your reason here..."
        fullWidth
        required
        disabled={isLoading}
      />

      <ButtonContainer>
        <Button variant="primaryDestructive" onClick={onWaiveSubmit} disabled={!reason.trim() || isLoading}>
          {isLoading ? <CircularProgress color="inherit" size={16} /> : 'Waive Break'}
        </Button>
      </ButtonContainer>
    </StepContentContainer>
  );
};

WaiverConfirmationStep.propTypes = {
  selectedBreak: PropTypes.object,
  reason: PropTypes.string.isRequired,
  setReason: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  onWaiveSubmit: PropTypes.func.isRequired,
};

export default WaiverConfirmationStep;
